/**
 * Created by piotr.pozniak@thebeaverhead.com on 17/08/2022
 */

import React, { useCallback, useState } from "react";
import classnames from "classnames";

/**
 *
 * @param {string=""} wrapperClassName
 * @param {string} errorLevel
 * @param {string} icon
 * @param {string|object} header
 * @param {Object} body
 * @returns {Element}
 * @constructor
 */
const ExpandableAlert = ({
  wrapperClassName = "",
  errorLevel,
  icon,
  header,
  body,
}) => {
  const [expanded, setExpanded] = useState(false);

  const onExpandClick = useCallback(
    (e) => {
      e.preventDefault();

      setExpanded(!expanded);
    },
    [expanded]
  );

  return (
    <div
      className={classnames(
        "alert word-break-words d-flex alert-expandable",
        `alert-${errorLevel}`,
        wrapperClassName
      )}
    >
      <p className={"m-r-5 m-b-0"}>
        <i className="material-icons icon-sm glowing-icon">{icon}</i>
      </p>
      <div className={"alert-expandable-content"}>
        <div className={"alert-expandable-header"}>
          <a
            className={"d-inline-flex justify-content-between link-read-more"}
            href={"#"}
            onClick={onExpandClick}
          >
            <p className={"m-b-0 m-r-5 d-inline-flex title"}>{header}</p>
            {/*<span>Read {expanded ? "less " : "more "}</span>*/}
            <span className={"d-flex"}>
              <i className={"material-icons"}>
                {expanded ? "keyboard_arrow_up" : "keyboard_arrow_down"}
              </i>{" "}
            </span>
          </a>
        </div>
        {expanded ? <p className={"content"}>{body}</p> : null}
      </div>
    </div>
  );
};

export default ExpandableAlert;
